import type { SchemaBuilderFieldEditorProps } from "./schema-builder-field-editor.type";

import { Button, Col, Form, Row } from "antd";
import { useTranslation } from "react-i18next";

import { SchemaBuilderConditions } from "../schema-builder-condition";
import { SchemaBuilderFieldTypePicker } from "../schema-builder-field-type";

import { SchemaBuilderFieldEditorContent } from "./schema-builder-field-editor-content";
import { useSchemaBuilderFieldEditor } from "./schema-builder-field-editor.hook";

export const SchemaBuilderFieldEditor = (
  props: SchemaBuilderFieldEditorProps
) => {
  const { t } = useTranslation();

  const {
    schema,
    form,
    fieldType,
    initialValues,
    onTypeChange,
    onFormSubmit,
    isNewField,
    isEditableField,
    valuesAreEquals,
  } = useSchemaBuilderFieldEditor(props);

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={initialValues}
      onFinish={onFormSubmit}
      role="form"
    >
      <Row gutter={16} justify="center">
        <Col xs={22} lg={8}>
          <SchemaBuilderFieldTypePicker
            name="fieldType"
            onTypeChange={onTypeChange}
            showAll={!isEditableField}
            disabled={!isEditableField}
            required
          />
        </Col>
        <Col xs={22} lg={16}>
          <SchemaBuilderFieldEditorContent
            schema={schema}
            fieldType={fieldType}
            initialValues={initialValues}
          />
          {isEditableField && (
            <SchemaBuilderConditions
              name="conditions"
              initialValues={initialValues["conditions"]}
            />
          )}
          <Form.Item shouldUpdate>
            <Button
              type="primary"
              htmlType="submit"
              disabled={!isEditableField || valuesAreEquals}
            >
              {isNewField ? t("global:add") : t("global:update")}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
